module.exports = __webpack_public_path__ + "media/images/my_apps/ohap_my_apps_atlas_banner_2020-2ea811f70f71295b725983fc7e8e8e9e.png";